module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/4f78e2dbcd0ec251293e5a21bf3bec67.svg";